import React from 'react';

import QueryingRequestV2DefinitionPage from './RequestV2DefinitionPage';

export default function RequestV2DefinitionTabView({
  requestV2DefinitionId,
}: {
  requestV2DefinitionId: string;
}): JSX.Element {
  return (
    <div className="react-tab-container" style={{padding: 0}}>
      <QueryingRequestV2DefinitionPage requestV2DefinitionId={requestV2DefinitionId} />
    </div>
  );
}
